import { ChangeDetectionStrategy, Component, OnDestroy, signal, inject, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { DateAdapter, MAT_DATE_FORMATS, provideNativeDateAdapter } from '@angular/material/core';
import { MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';
import { CALENDAR_HEADER_CONFIG, CalendarHeaderConfig } from './header-config.token';
import { CalendarHeaderNavigationService } from './calendar-header-navigation.service';

@Component({
	selector: 'lib-custom-mat-calendar-header',
	standalone: true,
	providers: [provideNativeDateAdapter()],
	imports: [MatFormFieldModule, MatInputModule, MatDatepickerModule, MatButtonModule, MatIconModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './custom-mat-calendar-header.component.html',
	styleUrl: './custom-mat-calendar-header.component.scss',
})
export class CustomMatCalendarHeaderComponent<D> implements OnDestroy {
	private _calendar = inject<MatCalendar<D>>(MatCalendar);
	private _dateAdapter = inject<DateAdapter<D>>(DateAdapter);
	private _dateFormats = inject(MAT_DATE_FORMATS);

	private _destroyed = new Subject<void>();

	readonly periodLabel = signal('');

	constructor(@Inject(CALENDAR_HEADER_CONFIG) public config: CalendarHeaderConfig,
		private headerService: CalendarHeaderNavigationService) {
		this._calendar.stateChanges.pipe(startWith(null), takeUntil(this._destroyed)).subscribe(() => {
			this.periodLabel.set(
				this._dateAdapter
					.format(this._calendar.activeDate, this._dateFormats.display.monthYearLabel)
					.toLocaleUpperCase(),
			);
		});
	}
	ngOnDestroy() {
		this._destroyed.next();
		this._destroyed.complete();
	}

	previousClicked(mode: 'month' | 'year') {
		this._calendar.activeDate =
			mode === 'month'
				? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1)
				: this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);

		this.headerService.emitAction(mode === 'month' ? 'prevMonth' : 'prevYear');
	}

	nextClicked(mode: 'month' | 'year') {
    console.log('nextClicked', this._calendar.activeDate, this._calendar.maxDate);
    // if (this._calendar.activeDate) {

    // }
		this._calendar.activeDate =
			mode === 'month'
				? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1)
				: this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
				
		this.headerService.emitAction(mode === 'month' ? 'nextMonth' : 'nextYear');
	}

	previousEnabled(mode: 'month' | 'year'): boolean {
    // console.log('previousEnabled', this._calendar.minDate);
		if (!this._calendar.minDate) return true;

		const targetDate =
			mode === 'month'
				? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1)
				: this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);

      // console.log('clamp', this._dateAdapter.clampDate(targetDate, this._calendar.minDate, this._calendar.maxDate), this._dateAdapter.compareDate(this._dateAdapter.clampDate(targetDate, this._calendar.minDate, this._calendar.maxDate), this._calendar.minDate));

		return this._dateAdapter.compareDate(this._dateAdapter.clampDate(targetDate, this._calendar.minDate, this._calendar.maxDate), this._calendar.minDate) >= -1;
	}

	nextEnabled(mode: 'month' | 'year'): boolean {
    console.log('nextEnabled', this._calendar.maxDate);
		if (!this._calendar.maxDate) return true;

		const targetDate =
			mode === 'month'
				? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1)
				: this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);

    console.log('clamp', this._dateAdapter.clampDate(targetDate, this._calendar.minDate, this._calendar.maxDate), this._dateAdapter.compareDate(this._dateAdapter.clampDate(targetDate, this._calendar.minDate, this._calendar.maxDate), this._calendar.maxDate));
    console.log(this._dateAdapter.getMonth(this._dateAdapter.clampDate(targetDate, this._calendar.minDate, this._calendar.maxDate)), this._dateAdapter.getMonth(this._calendar.maxDate));


		return this._dateAdapter.compareDate(this._dateAdapter.clampDate(targetDate, this._calendar.minDate, this._calendar.maxDate), this._calendar.maxDate) <= 1;
    // return this._dateAdapter.getMonth(this._dateAdapter.clampDate(targetDate, this._calendar.minDate, this._calendar.maxDate)) <= this._dateAdapter.getMonth(this._calendar.maxDate);
	}
	
}
